<template>
  <div class="mainChild page-content" id="mainChild">
    <div>
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item>智慧服务</el-breadcrumb-item>
        <el-breadcrumb-item>品牌筛选列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <section style="padding: 20px;margin-bottom: 10px;background-color: white;">
      <section class="seaerch-wrapper" style="padding: 0px;margin: 0px;">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="关键词" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入" v-model="list.keyword" size="small"></el-input>
          </el-form-item>
          <el-form-item label="客户类型" :label-width="formLabelWidth">
            <el-select v-model="list.type" placeholder="请选择" size="small" clearable>
              <el-option label="公海客户" value="公海客户"></el-option>
              <el-option label="未记录客户" value="未记录客户"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" :label-width="formLabelWidth">
            <el-date-picker v-model="list.searchformDate" type="daterange" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd" range-separator="~" size="small">
            </el-date-picker>
          </el-form-item>
          <el-form-item></el-form-item>
          <el-form-item></el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="getIprPluginListList(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </section>

    <section class="content-warpper">
      <div class="headerBrand">
        <div class="searchContainer">
          <div class="downBtn">
            <el-button @click="deleteChange()" size="small">批量删除</el-button>
            <el-button @click="openCookieEntry()" size="small">cookie录入</el-button>
            <el-button @click="marking('撞单验证')" size="small">撞单验证</el-button>
            <el-button @click="openUrl()" size="small">验证链接</el-button>
            <el-button @click="download" size="small">下载</el-button>
          </div>
        </div>
      </div>
      <div class="downContainer">
        <el-table ref="multipleTable" :data="tableList" tooltip-effect="dark" style="width: 100%"
          v-loading="dataLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="brandname" label="品牌名称"></el-table-column>
          <el-table-column prop="keyword" label="搜索关键词"></el-table-column>
          <el-table-column prop="type" label="客户类型"></el-table-column>
          <el-table-column prop="detailsNum" label="验证结果"></el-table-column>
          <el-table-column prop="last_contact_date" label="最后联系时间"></el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope" v-if="scope.row.createtime">
              {{ scope.row.createtime | fullTime }}
            </template>
          </el-table-column>
          <el-table-column label="验证链接状态">
            <template slot-scope="scope">
              <el-button type="primary" @click="findPageKeywordBrandDetails(scope.row.id)" size="mini"
                :disabled="scope.row.detailsNum == 0">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column label="联系方式状态">
            <template slot-scope="scope">
              <el-button type="primary" @click="findKeywordBrandDetails(scope.row.id)" size="mini"
                :disabled="scope.row.contactNum == 0">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <!-- 企搜客 + 寻客宝 合并为"获取联系方式" -->
              <el-button @click="openMobil(scope.row.id, '获取联系方式', scope.row.company_name, scope.row.brandname)" type="text"
                size="small">获取联系方式</el-button>
              <el-button @click="openMobil(scope.row.id, '企客宝', scope.row.company_name)" type="text"
                size="small">企客宝</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-if="tableList && tableList.length > 0" :currentPage="paginae.currentPage"
          :pageSizes="paginae.pageSizes" :total="paginae.total" @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </section>
    <!--关键词设置弹窗-->
    <el-dialog :title="dialogName" :visible.sync="markingShow" width="360px" height="278" size="small">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="关键词：" label-width="120px" required>
          <el-input :clearable="true" placeholder="请输入关键词" v-model="paChongPageWard" size="small"></el-input>
        </el-form-item>
        <el-form-item label="品牌：" label-width="120px" required>
          <el-input :clearable="true" placeholder="请输入品牌" v-model="brands" size="small"></el-input>
        </el-form-item>
        <!-- <el-form-item label="cookie：" label-width="120px" required>
          <el-input :clearable="true" placeholder="请输入cookie" v-model="cookie" size="small" type="textarea"
            :rows="2"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="keyword_search" v-loading="keyLoading">确 定</el-button>
        <el-button @click="markingShow = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>
    <!--联系方式-->
    <el-dialog :title="openMobilName" :visible.sync="mobilShow" width="420px" height="278" size="small">
      <el-form class="search-form">
        <el-form-item label="公司名称：" label-width="140px" required v-if="openMobilName != '企客宝'">
          <el-input :clearable="true" placeholder="请输入公司名称" v-model="companyName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="cookie：" label-width="140px" required v-else>
          <el-input :clearable="true" placeholder="请输入cookie" v-model="header" type="textarea" :rows="2"
            size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="getMobil" v-loading="mobilLoading">确 定</el-button>
        <el-button @click="mobilShow = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>
    <!--Cookie录入（三平台凭证）-->
    <el-dialog title="cookie录入" :visible.sync="cookieEntryShow" width="520px" height="278" size="small">
      <el-form class="search-form">
        <el-form-item label="企客宝Cookie：" label-width="140px" required>
          <el-input :clearable="true" placeholder="请输入企客宝Cookie" v-model="q" type="textarea" :rows="2"
            size="small"></el-input>
        </el-form-item>
        <el-form-item label="寻客宝Header：" label-width="140px" required>
          <el-input :clearable="true" placeholder="请输入寻客宝Header" v-model="w" type="textarea" :rows="2"
            size="small"></el-input>
        </el-form-item>
        <el-form-item label="企搜客Header：" label-width="140px" required>
          <el-input :clearable="true" placeholder="请输入企搜客Header" v-model="e" type="textarea" :rows="2"
            size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="submitCookieEntry" v-loading="cookieEntryLoading">确 定</el-button>
        <el-button @click="cookieEntryShow = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>
    <!--验证链接-->
    <el-dialog title="验证链接" :visible.sync="urlShow" width="360px" height="278" size="small">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="页数：" label-width="120px" required>
          <el-input :clearable="true" placeholder="请输入页数" v-model="pagelinkNum" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="getUrl" v-loading="urlLoading">确 定</el-button>
        <el-button @click="urlShow = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 验证链接 -->
    <el-dialog title="验证链接" :visible.sync="urlDetilShow" width="800px" size="small">
      <div class="downContainer">
        <el-table ref="multipleTable" :data="urlDetilData" tooltip-effect="dark" style="width: 100%" max-height="300px"
          v-loading="urlDetiLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
          <el-table-column prop="title" label="链接标题"></el-table-column>
        </el-table>
        <pagination v-if="urlDetilData && urlDetilData.length > 0" :currentPage="paginae2.currentPage"
          :pageSizes="paginae2.pageSizes" :total="paginae2.total" @handleSizeChange="handleSizeChange2"
          @handleCurrentChange="handleCurrentChange2">
        </pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="urlDetilShow = false" size="small" type="cancel_blue">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 联系方式 -->
    <el-dialog title="联系方式" :visible.sync="mobilDetilShow" width="360px" size="small">
      <div class="downContainer">
        <el-table ref="multipleTable" :data="mobilDetilData" tooltip-effect="dark" style="width: 100%"
          max-height="300px" v-loading="dataLoading" element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading">
          <el-table-column label="联系方式">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="copyContactInfo(scope.row.contact_info)"
                style="color: #409EFF; cursor: pointer;">
                {{ scope.row.contact_info }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyAll()" size="small" type="primary">一键复制</el-button>
        <el-button @click="mobilDetilShow = false" size="small" type="cancel_blue">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 批量删除 -->
    <el-dialog :visible.sync="deleteShow" width="360px" style="margin-top: 10%;" title="提示" id="dialog">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
          <div style="font-size: 16px;">你确认要删除{{ this.urlList.length }}条信息吗？</div>
          <div style="font-size: 14px;">删除后
            <span style="color: #e90e24;font-size: 14px;">信息将无法找回</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteByBmcid()" size="small" :loading="allDelLoading">确 定</el-button>
        <el-button @click="deleteShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from "@/components/dataTable/pagination";

export default {
  name: "brandStore",
  data() {
    return {
      allDelLoading: false,
      deleteShow: false,
      urlDetiLoading: false,
      urlDetilShow: false,
      urlDetilData: [],
      mobilDetilShow: false,
      mobilDetilData: [],
      dataLoading: false,
      tableList: [],
      list: {
        pageNo: 1,
        pageSize: 10,
        keyword: "",
        type: "",
        searchformDate: [],
      },
      list2: {
        pageNo: 1,
        pageSize: 10,
      },
      paginae: {
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
        total: 0
      },
      paginae2: {
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
        total: 0
      },
      formLabelWidth: "100px",
      dialogName: '',
      paChongPageWard: '',
      brands: '',
      // cookie: '',
      markingShow: false,
      keyLoading: false,
      mobilShow: false,
      keywordBrandId: '',
      companyName: '',
      brandname: '', // 品牌名称（获取联系方式传参用）
      // mobilCookie: '',
      mobilLoading: false,
      pagelinkNum: '',
      urlShow: false,
      urlLoading: false,
      urlList: [],
      openMobilName: '',
      // 三平台凭证（cookie录入用）
      q: '', // 企客宝 Cookie
      w: '', // 寻客宝 Header
      e: '', // 企搜客 Header
      cookieEntryShow: false,
      cookieEntryLoading: false,
      // acsToken: '',
      // userInfo: '',
      header: '',
    };
  },
  mounted() {
    this.getIprPluginListList();
  },
  methods: {
    deleteChange() {
      if (this.urlList.length == 0) {
        this.$message({
          message: '没有选中项',
          type: 'warning'
        });
        return
      }
      this.deleteShow = true
    },
    // 确认删除
    deleteByBmcid() {
      this.allDelLoading = true;
      let arr = [];
      this.urlList.forEach((val, index, val_arr) => {
        arr.push(val.id)
      });
      // this.deleteId = arr.join(',')
      let params = {
        ids: arr.join(','),
      }
      fetch({
        url: "hcm/iprKeywordBrand/deleteKeywordBrand",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        if (res.status == '10000') {
          this.allDelLoading = false;
          this.deleteShow = false;
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getIprPluginListList();
        } else {
          this.allDelLoading = false;
        }
      })
    },
    copyAll() {
      if (this.mobilDetilData.length == 0) {
        this.$message.warning("暂无可复制的联系方式");
        return;
      }
      let contactInfos = this.mobilDetilData.map(item => item.contact_info).join('\n');
      // 使用现代剪贴板 API
      if (navigator.clipboard) {
        navigator.clipboard.writeText(contactInfos).then(() => {
          this.$message.success('所有联系方式已复制到剪贴板');
        }).catch(err => {
          console.error('复制失败:', err);
        });
      }
    },
    handleSelectionChange(val) {
      this.urlList = [];
      for (let a in val) {
        this.urlList.push({
          keyword: val[a].keyword,
          brandname: val[a].brandname,
          id: val[a].id
        });
      }
    },
    // 复制联系方式到剪贴板
    copyContactInfo(contactInfo) {
      if (!contactInfo) {
        this.$message.warning('没有可复制的联系方式');
        return;
      }
      // 使用现代剪贴板 API
      if (navigator.clipboard) {
        navigator.clipboard.writeText(contactInfo).then(() => {
          this.$message.success('联系方式已复制到剪贴板');
        }).catch(err => {
          console.error('复制失败:', err);
          this.fallbackCopyTextToClipboard(contactInfo);
        });
      } else {
        // 降级方案：使用传统方法
        this.fallbackCopyTextToClipboard(contactInfo);
      }
    },
    // 打开联系方式
    openMobil(id, name, companyName, brandname) {
      this.openMobilName = name;
      this.companyName = companyName;
      this.brandname = brandname || '';
      if (name == '企客宝') {
        this.header = this.obj.qikebao_cookie;
      } else {
        // 获取联系方式：不再传 header
        this.header = '';
      }
      this.keywordBrandId = id;
      this.mobilShow = true;
    },
    openUrl() {
      if (this.urlList.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }
      this.pagelinkNum = '';
      this.urlShow = true;
    },
    // 调用联系方式接口
    getMobil() {
      let url;
      let params = {
        keywordBrandId: this.keywordBrandId,
      }
      if (this.openMobilName == '企客宝') {
        if (!this.header) {
          this.$message.warning("请输入cookie");
          return;
        }
        params.cookie = this.header
        url = 'hcm/iprKeywordBrand/importToQikebao'
      } else {
        // 获取联系方式：企搜客/寻客宝合并，传 companyName + keywordBrandId + brandname，不传 header
        if (!this.companyName) {
          this.$message.warning("请输入公司名称");
          return;
        }
        params.companyName = this.companyName
        params.brandname = this.brandname
        url = 'hcm/iprKeywordBrand/getMobileByCompanyName'
      }
      fetch({
        url: url,
        method: "post",
        data: params,
        noFormat: false,
        responseType: "json",
        timeout: 60 * 1000 * 50
      }).then(res => {
        if (res.status == '10000') {
          this.mobilShow = false;
          this.mobilLoading = false;
          this.getIprPluginListList();
          this.$message.success(res.message)
        } else {
          this.mobilLoading = false;
          this.$message.error(res.message)
        }
      }).catch((res) => {
        this.mobilLoading = false;
      })
    },
    // 打开cookie录入弹窗（回显已有凭证）
    openCookieEntry() {
      this.q = (this.obj && this.obj.qikebao_cookie) || '';
      this.w = (this.obj && this.obj.xunkebao_header) || '';
      this.e = (this.obj && this.obj.qisouke_header) || '';
      this.cookieEntryShow = true;
    },
    // 提交三平台凭证（cookie录入）
    submitCookieEntry() {
      if (!this.q && !this.w && !this.e) {
        this.$message.warning("请至少填写一个平台的凭证");
        return;
      }
      this.cookieEntryLoading = true;
      let params = {
        qikebaoCookie: this.q,    // 企客宝 Cookie
        xunkebaoHeader: this.w,   // 寻客宝 Header
        qisoukeHeader: this.e     // 企搜客 Header
      };
      fetch({
        url: 'hcm/iprKeywordBrand/saveThreePlatformCookies',
        method: "post",
        data: params,
        noFormat: false,
        responseType: "json",
        timeout: 60 * 1000 * 50
      }).then(res => {
        if (res.status == '10000') {
          this.cookieEntryShow = false;
          this.cookieEntryLoading = false;
          this.$message.success(res.message)
        } else {
          this.cookieEntryLoading = false;
          this.$message.error(res.message)
        }
      }).catch((res) => {
        this.cookieEntryLoading = false;
      })
    },
    findKeywordBrandDetails(id) {
      let params = {
        keywordBrandId: id
      }
      fetch({
        url: "hcm/iprKeywordBrand/findKeywordBrandDetails",
        method: "post",
        data: params,
        noFormat: false,
        responseType: "json",
        timeout: 60 * 1000 * 50
      }).then(res => {
        if (res.status == '10000') {
          this.mobilDetilShow = true;
          this.mobilDetilData = res.data;
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      }).catch((res) => {

      })
    },
    findPageKeywordBrandDetails(id) {
      if (id) {
        this.list2.pageNo = 1;
        this.paginae2.currentPage = 1;
        this.keywordBrandId = id;
      }

      this.urlDetiLoading = true;

      const params = {
        pageNo: this.list2.pageNo,
        pageSize: this.list2.pageSize,
        keywordBrandId: this.keywordBrandId
      };

      fetch({
        url: "hcm/iprKeywordBrand/findPageKeywordBrandDetails",
        method: "post",
        data: params,
        noFormat: false,
        responseType: "json",
        timeout: 60 * 1000 * 50
      }).then(res => {
        if (res.status === '10000') {
          this.urlDetilShow = true;
          this.urlDetilData = res.data.content || [];
          this.paginae2.total = res.data.totalElements || 0;
          this.paginae2.currentPage = this.list2.pageNo;
          if (id) {
            this.$nextTick(() => {
              this.paginae2.currentPage = 1;
            });
          }

        } else {
          this.$message.error(res.message);
        }
      }).finally(() => {
        this.urlDetiLoading = false;
      });
    },
    // 获取url关联链接
    getUrl() {
      if (!this.pagelinkNum) {
        this.$message.warning("请输入页数");
        return;
      }
      this.urlLoading = true;
      // let params = {
      //   pagelinkNum: this.pagelinkNum,
      //   ...this.list
      // }
      fetch({
        url: "hcm/iprKeywordBrand/verifyAndSaveDetails?pagelinkNum=" + this.pagelinkNum,
        method: "post",
        data: JSON.stringify(this.urlList),
        headers: {
          'Content-Type': 'application/json'
        },
        noFormat: false,
      }).then(res => {
        if (res.status == '10000') {
          this.urlShow = false;
          this.urlLoading = false;
          this.$message.success(res.data)
          this.getIprPluginListList();
        } else {
          this.$message.error(res.data)
        }
      }).catch((res) => {
        this.urlLoading = false;
      })
    },
    // 打开关键词设置弹窗
    marking(name) {
      this.dialogName = name;
      this.paChongPageWard = '';
      this.brands = '';
      this.markingShow = true;
    },
    // 关键词搜索
    keyword_search() {
      if (!this.paChongPageWard) {
        this.$message.warning("请输入关键词");
        return;
      }
      // if (!this.cookie) {
      //   this.$message.warning("请输入cookie值");
      //   return;
      // }
      if (!this.brands) {
        this.$message.warning("请输入品牌");
        return;
      }
      let data = {
        keyword: this.paChongPageWard,
        // cookie: this.cookie,
        brands: this.brands
      };
      this.keyLoading = true;
      fetch({
        url: "hcm/iprKeywordBrand/checkBrandCollision",
        method: "post",
        data: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
        },
        noFormat: false,
        responseType: "json",
        timeout: 60 * 1000 * 50
      }).then(res => {
        if (res.status == '10000') {
          this.keyLoading = false;
          this.$message.success('设置成功');
          this.markingShow = false;
        } else {
          this.keyLoading = false;
          this.$message.warning(res.message);
        }
      }).catch(() => {
        this.keyLoading = false;
        this.$message.error('请求失败');
      });
    },
    getIprPluginListList(e) {
      this.dataLoading = true;
      if (e == 1) {
        this.paginae.currentPage = 1;
        this.list.pageNo = 1;
      }
      let params = {
        pageNo: this.list.pageNo,
        pageSize: this.list.pageSize,
      };
      if (this.list.keyword) {
        params.keyword = this.list.keyword;
      }
      if (this.list.type) {
        params.type = this.list.type;
      }
      if (this.list.searchformDate && this.list.searchformDate.length == 2) {
        params.starttime = this.list.searchformDate[0];
        params.endtime = this.list.searchformDate[1];
      }

      fetch({
        url: "hcm/iprKeywordBrand/findPageKeywordBrand",
        method: "post",
        data: params,
        timeout: 60 * 1000 * 5
      }).then(res => {
        if (res.status == "10000") {
          this.tableList = res.data.content || [];
          this.paginae.total = res.data.totalElements || 0;
          this.obj = res.data.obj;
          // this.cookie = res.data.obj.qikebao_cookie;
        } else {
          this.tableList = [];
          this.paginae.total = 0;
        }
        this.dataLoading = false;
        this.paginae.currentPage = this.list.pageNo;
      }).catch(() => {
        this.tableList = [];
        this.paginae.total = 0;
        this.dataLoading = false;
      });
    },
    handleSizeChange(val) {
      this.list.pageSize = val;
      this.getIprPluginListList();
    },
    handleSizeChange2(val) {
      this.list2.pageSize = val;
      this.findPageKeywordBrandDetails();
    },
    handleCurrentChange(val) {
      this.list.pageNo = val;
      this.getIprPluginListList();
    },
    handleCurrentChange2(val) {
      this.list2.pageNo = val;
      this.findPageKeywordBrandDetails();
    },
    // 下载
    download() {
      let datas = {};
      if (this.list.keyword) {
        datas.keyword = this.list.keyword;
      }
      if (this.list.type) {
        datas.type = this.list.type;
      }
      if (this.list.searchformDate && this.list.searchformDate.length == 2) {
        datas.starttime = this.list.searchformDate[0];
        datas.endtime = this.list.searchformDate[1];
      }
      fetch({
        url: "hcm/iprKeywordBrand/exportKeywordBrand",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "blob"
      }).then((res) => {
        //下载
        let url = window.URL.createObjectURL(new Blob([res]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '品牌筛选列表.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
  },
  components: {
    pagination
  }
};
</script>

<style scoped lang="scss">
.mainChild {
  .content-warpper {
    min-height: 766px;
  }

  .downContainer {
    margin-top: 5px;
  }
}
</style>